import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'; // 1. useParams 추가 (URL의 id를 가져오기 위해)
import './NoticeWrite.css'; // 스타일은 쓰던 것 그대로 사용
import { Banner } from '../../../components/Banner/Banner';
import topImage from '../../../assets/images/BannerTop.png';
import { Footer } from '../../../components/Footer/Footer';
import { Navbar } from '../../../components/Navbar/Navbar';

// 모달 컴포넌트
const Modal = ({ message, onClose }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <p>{message}</p>
                <button onClick={onClose} className="modal-close-btn">확인</button>
            </div>
        </div>
    );
};

export const NoticeEdit = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    
    // 2. URL에서 수정할 게시물의 id를 가져옵니다.
    const { id } = useParams(); 
    
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    // 3. 페이지 로드 시: 기존 게시물 데이터를 가져와서 input에 채워넣기
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setModalMessage('로그인 후 이용 가능합니다.');
            setShowModal(true);
            setTimeout(() => navigate('/adLogin', { replace: true }), 800);
            return;
        }

        // 기존 데이터 Fetch
        const fetchPost = async () => {
            try {
                const response = await fetch(`${BOARD_URL}/posts/${id}`);
                if (!response.ok) {
                    throw new Error('게시물을 불러올 수 없습니다.');
                }
                const data = await response.json();
                // 받아온 데이터로 상태 업데이트 (화면에 기존 글 표시)
                setTitle(data.title);
                setContent(data.content);
            } catch (error) {
                console.error(error);
                setModalMessage('존재하지 않거나 삭제된 게시물입니다.');
                setShowModal(true);
                setTimeout(() => navigate('/notice'), 1000);
            }
        };

        fetchPost();
    }, [id, navigate, BOARD_URL]);

    const closeModal = () => {
        setShowModal(false);
        setModalMessage('');
    };

    // 4. 수정 완료 버튼 클릭 시: PUT 요청 보내기
    const handleUpdate = async () => {
        if (!title.trim() || !content.trim()) {
            setModalMessage('제목과 내용을 모두 입력해 주세요.');
            setShowModal(true);
            return;
        }

        const token = localStorage.getItem('token');
        
        try {
            // URL 뒤에 id를 붙이고, method를 PUT으로 변경
            const res = await fetch(`${BOARD_URL}/posts/${id}`, {
                method: 'PUT', 
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ title, content }),
            });

            const data = await res.json();
            
            if (res.ok) {
                setModalMessage('게시물이 성공적으로 수정되었습니다.');
                setShowModal(true);
                // 수정 후 해당 게시물 상세 페이지 혹은 목록으로 이동
                setTimeout(() => {
                    navigate(`/notice/${id}`); 
                }, 1500);
            } else {
                setModalMessage(data.message || '게시물 수정에 실패했습니다.');
                setShowModal(true);
            }
        } catch (err) {
            console.error(err);
            setModalMessage('서버와 통신 중 오류가 발생했습니다.');
            setShowModal(true);
        }
    };

    return (
        <>
            <Navbar />
            <Banner title="공지사항 수정" />

            <div className="adNotice-container">
                <input
                    className="adNotice-input"
                    type="text"
                    placeholder="제목을 입력해 주세요."
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                />

                <textarea
                    className="adNotice-textarea"
                    placeholder="내용을 입력하세요."
                    value={content}
                    onChange={e => setContent(e.target.value)}
                />

                <div className="adNotice-btn-wrap">
                    <button
                        className="adNotice-btn"
                        onClick={handleUpdate} // 함수 이름 변경 (createPost -> handleUpdate)
                    >
                        수정 완료
                    </button>
                    {/* 취소 버튼도 있으면 좋습니다 */}
                    <button 
                        className="adNotice-btn" 
                        style={{backgroundColor: '#6c757d', marginLeft: '10px'}}
                        onClick={() => navigate('/notice')}
                    >
                        취소
                    </button>
                </div>
            </div>

            <Footer />
            {showModal && <Modal message={modalMessage} onClose={closeModal} />}
        </>
    );
};